import React from 'react'
import {connect} from 'react-redux'
import PT from 'prop-types'
import {isNode} from '../../utils'
import {H5_LANGUAGE} from '../../constants/enum'
import {isSocial} from '../../utils/ua'

class VipAutoRenew extends React.Component {
  componentDidMount() {}

  render() {
    const {deviceInfo, hostname} = this.props
    if (isSocial(hostname)) {
      if (!isNode()) {
        const lang = deviceInfo.h_lang || H5_LANGUAGE.alias2Text('english')
        this.props.history.replace(`/hybrid/vip/autoRenew/${lang}`)
      }
    } else {
      this.props.history.replace('/404')
    }
    return null
  }
}

VipAutoRenew.propTypes = {
  history: PT.shape({
    replace: PT.func,
  }).isRequired,
  deviceInfo: PT.shape({
    h_lang: PT.string,
  }).isRequired,
  hostname: PT.string.isRequired,
}

export default connect(state => {
  const {
    deviceinfo,
    env: {hostname},
  } = state
  const deviceInfo = deviceinfo
  return {deviceInfo, hostname}
})(VipAutoRenew)
